import React from 'react'
import { Box } from '@mui/material'
import EmptyScreen from 'packages/ui/EmptyScreen'

interface WidgetContainerProps {
  width: { xs: string; sm: string; md: string; lg?: string; xl?: string }
  minHeight?: string
  children: React.ReactNode
  error?: boolean
  isEmpty?: boolean
  emptyIcon: string
  emptyMessage: string
  loading?: boolean
  LoadingComponent?: React.ComponentType
}

const WidgetContainer: React.FC<WidgetContainerProps> = ({
  width,
  minHeight = '100px',
  children,
  error,
  isEmpty,
  emptyIcon,
  emptyMessage,
  loading,
  LoadingComponent
}) => {
  if (loading && LoadingComponent) {
    return <LoadingComponent />
  }

  if (error || isEmpty) {
    return (
      <Box
        sx={{
          width,
          border: '1px dashed #D7DAEA',
          borderRadius: '16px',
          padding: 2,
          backgroundColor: '#FFFFFF',
          minHeight,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <EmptyScreen 
          icon={emptyIcon}
          variant="compact"
          iconSize="20px"
          fontSize="12px"
          spacing={1}
        >
          {emptyMessage}
        </EmptyScreen>
      </Box>
    )
  }

  return (
    <Box
      sx={{
        width,
        border: '1px solid #EFEFEF',
        borderRadius: '16px',
        padding: 2,
        backgroundColor: '#FFFFFF',
        minHeight,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      {children}
    </Box>
  )
}

export default WidgetContainer